import $ from 'jquery';
import ReloadableComponentPrototype from 'ReloadableComponentPrototype';
export default class ContentCentralArticleGrid extends ReloadableComponentPrototype {
  build() {
    // const canSubscribeToFiltersChangeEvent = !!this.getParent();
    this.eventBus.subscribe(this, 'filters_changed', this.onFilterChange);
    this.setLoadMoreArticlesButtonEventListener();
    this.afterBuild();
  }

  setLoadMoreArticlesButtonEventListener() {
    const loadMoreButtonSelector = '.content-central-article-grid__load-more-button > .button';

    this.node.on('click', loadMoreButtonSelector, (event) => {
      event.preventDefault();
      const loadMoreContainer = $(event.target).closest('.content-central-article-grid__load-more-button-container');
      const loadMoreArticlesUrl = loadMoreContainer.data('moreurl');

      // Remove existing "Load more" button since a new one will be included in the response
      this.node
        .find('.content-central-article-grid__load-more-spinner')
        .removeClass('content-central-article-grid__load-more-spinner--hidden');
      loadMoreContainer.remove();

      this.loadMoreArticles(loadMoreArticlesUrl);
    });
  }

  loadMoreArticles(baseUrl) {
    const articleRequestUrl = this.parseLoadMoreArticlesUrl(baseUrl);

    $.get(articleRequestUrl).done((data) => {
      this.node.find('.content-central-article-grid__load-more-spinner').remove();
      this.createNewArticleTeasersFromReceivedData(data);
    });
  }

  parseLoadMoreArticlesUrl(baseUrl) {
    const offset = Number(this.node.data('offset'));
    const amount = Number(this.node.data('amount'));
    const categories = this.node.data('categories');
    const person = this.node.data('person');

    const articleSelector = '.content-central-article-teaser__article';
    const teaserCount = this.node.find(articleSelector).length;
    let urlWithQueryParameters = baseUrl;

    urlWithQueryParameters += baseUrl.indexOf('?') !== -1 ? '&' : '?';
    urlWithQueryParameters += `start=${teaserCount + offset}&amount=${amount}`;

    if (person) {
      urlWithQueryParameters += `&name=${person}`;
    }

    if (categories) {
      urlWithQueryParameters += `&kategoriat=${categories}`;
    }

    return urlWithQueryParameters;
  }

  createNewArticleTeasersFromReceivedData(data) {
    const articleGridHtml = $(data);
    const teasers = articleGridHtml.find('.content-central-article-grid__teaser-container');
    const button = articleGridHtml.find('.content-central-article-grid__load-more-button-container');
    const loader = articleGridHtml.find('.content-central-article-grid__load-more-spinner');

    teasers.appendTo(this.node);
    button.appendTo(this.node);
    loader.appendTo(this.node);
  }

  onFilterChange(filters) {
    this.reloadComponentHTML(filters);
  }

  reloadComponentHTML(params = {}) {
    this.eventBus.publishTo(this.id, 'reload_started');

    $.get(this.href, params).done((element) => {
      this.eventBus.publishTo(this.id, 'reload_ready', $(element));
    });
    this.build();
  }

}
